/**
 * Every scheduler config runs on 30-minute slots for now — it is not exposed for editing, and is
 * forced on save so a config cannot drift to another value. Occupancy, the areas timeline and the
 * close-area dialog all derive their grid from this, so changing it is a product decision rather
 * than a per-account setting.
 */
export const FIXED_SLOT_MINUTES = 30;
